import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Typography, Box } from '@mui/material/';
import { getIn } from 'formik';

interface values {
    value: any;
    label: string;
    useComponent?: boolean;
    component?: JSX.Element;
    specificAction?: any;
}
interface RadioButtonProps {
    disabled?: boolean;
    formik: any;
    values: values[];
    radioGroupName: string;
    formLabel?: string;
    customAction?: any;
    labelVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'body1' | 'body2';
    individualRowStyle?: any;
    row?: boolean;
    rowsToApplyIndividualStylesFor?: any;
    tooltipMap?: { [value: string]: JSX.Element };
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function RadioButton({
    disabled,
    formik,
    values,
    formLabel,
    customAction,
    radioGroupName,
    labelVariant,
    individualRowStyle,
    rowsToApplyIndividualStylesFor,
    row = false,
    tooltipMap = {},
    onChange
}: RadioButtonProps) {
    return (
        <FormControl disabled={disabled}>
            <FormLabel>{formLabel}</FormLabel>
            <RadioGroup
                row={row}
                name={radioGroupName}
                value={formik.values[radioGroupName]}
                onChange={onChange ?? formik.handleChange}
            >
                {values.map(({ value, label, useComponent, component, specificAction }, i) => (
                    <Box key={i} sx={i === rowsToApplyIndividualStylesFor ? individualRowStyle : {}}>
                        <FormControlLabel
                            key={i}
                            value={value}
                            control={
                                <Radio
                                    checked={value === getIn(formik.values, radioGroupName)?.toString()}
                                    onClick={(e) => {
                                        if (customAction) {
                                            customAction(e);
                                        }
                                        if (specificAction) {
                                            specificAction(e);
                                        }
                                    }}
                                />
                            }
                            label={
                                <Box display="flex" alignItems="center">
                                    <Typography variant={labelVariant ? labelVariant : 'body1'}>
                                        {label}
                                    </Typography>
                                    {tooltipMap?.[value] && (
                                        <Box ml={0.5}>{tooltipMap[value]}</Box>
                                    )}
                                </Box>
                            }
                        />
                        {useComponent && getIn(formik.values, radioGroupName) === value && <> {component} </>}
                    </Box>
                ))}
            </RadioGroup>
        </FormControl>
    );
}

export { RadioButton };
